<template>
  <div class="aw-subject">
    <div class="com-sub-top">
      <div class="muli-title container-center">
        科研课题
        <span class="subject-sub-title">产学研结合，推动技术创新</span>
        <span class="subject-sub-desc">携手教育部，促进高校科研与教育深度融合</span>
      </div>
    </div>
    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">合作简介</p>
        <p class="desc">
          自2020年起，海云捷迅与教育部高等学校科学研究发展中心共同设立了“中国高校产学研创新基金”专项课题，旨在通过校企合作的方式，推动高校在人工智能、FPGA、大数据、云计算等前沿技术领域的研究与教学。
        </p>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">历年项目回顾</p>
        <div class="com-tab-box">
          <div class="p-box container-center">
            <p :class="{ active: key == '1' }" @click="choose('1')">
              2020年：“异构智能计算项目”
            </p>
            <p :class="{ active: key == '2' }" @click="choose('2')">
              2021年：“新一代信息技术创新项目”
            </p>
          </div>
        </div>
        <div class="tab-content">
            <div v-if="key == '1'">
                <p class="tab-desc">推动异构计算的应用和发展</p>
                <img class="subject-img1" src="@/assets/subject/subject_img_1@2x.png" alt="">
            </div>

            <div v-if="key == '2'">
                <p class="tab-desc">鼓励探索新一代信息技术的创新应用。</p>
                <img class="subject-img2" src="@/assets/subject/subject_img_2@2x.png" alt="">
            </div>
            <a class="aw-btn" @click="go(1)">点击查看</a>
        </div>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center">
        <p class="title">最新项目动态</p>
        <p class="small-title" stye>
            2024年：“中国高校产学研创新基金-异构智能计算专项(二期)”
        </p>
        <p class="dynamics-text">
            ▶ 支持范围涵盖人工智能、FPGA、大数据、云计算等领域。<br/>
            ▶ 目标是进一步促进信息技术与教育的深度融合，推动技术应用创新和产业升级。
        </p>
        <p class="dynamics-title">
            课题说明
        </p>
        <p class="dynamics-text">
            1. 为促进信息技术与教育深度融合，中心与北京海云捷迅科技股份有限公司联合设立“中国高校产学研创新基金-异构智能计算专项（二期）”，支持高校在人工智能、FPGA、大数据、云计算等领域的科学研究和教学实践，促进技术应用创新和产业升级。<br/>
            2. 根据确定的研究内容，“异构智能计算专项（二期）”为每个课题提供总经费为20万元至50万元的支持，其中研究经费10万元至25万元。课题申请人无需向资助企业额外购买配套设备或软件。<br/>
            3. 课题的选题方向和申请条件需符合《异构智能计算专项（二期）申请指南说明》（附件1）的要求。<br/>
            4. 课题的计划执行时间为2024年11月1日～2025年10月31日，可根据课题复杂程度适度延长执行周期，最长不超过两年。<br/>
            5. 资助课题获得的知识产权由资助方和课题承担单位共同所有。
        </p>
        <p class="dynamics-title">
            申报指南
        </p>
        <p class="dynamics-text">
            申报对象：全国各高校相关专业的教师及科研人员。
        </p>
        <p class="dynamics-title">
            申报流程
        </p>
        <p class="dynamics-text">
            ▶ 按照指南要求准备申报材料。<br/>
            ▶ 在规定时间内提交至指定邮箱。
        </p>
        <p class="dynamics-title">
            联系方式
        </p>
        <p class="dynamics-text">
            1. 教育部高等学校科学研究发展中心联系人：<br/>
            张杰 电话：010-62514689<br/>
            2. 北京海云捷迅科技股份有限公司联系人：<br/>
            姜楠 电话：18723098797<br/>
            冯辉 电话：13901376040<br/>
            田亮 电话：18500195230
        </p>
        <div style="text-align: center;">
            <a class="aw-btn apply-btn" @click="go(2)">立即申报</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      key: "1",
      subKey: "1"
    };
  },
  methods: {
    choose(val) {
      this.key = val;
    },
    subChoose(val) {
      this.subKey = val;
    },
    go(val) {
        if(val==1) {
            let url = this.key == '1' ? 'https://www.cutech.edu.cn/detail/46-382': 'https://www.cutech.edu.cn/detail/46-362'
            window.open(url, '_blank')
        }else {
            window.open('https://www.cutech.edu.cn/detail/46-421', '_blank')
        }
    }
  },
};
</script>